import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
    buildVersion: any = environment.buildVersion;
    constructor(private translate: TranslateService, private router: Router) {
        translate.setDefaultLang('en');
    }

    ngOnInit() {
        const val: any = localStorage.getItem('isUserLoggedIn');
        if (val == 'true') {
            this.router.navigate(['/dashboard']);
        }
    }
    customOptions: OwlOptions = {
        center: true,
        items: 1,
        loop: true,
        nav: false,
        dots: true,
        autoplay: true,
        slideTransition: 'linear',
        autoplaySpeed: 1000,
        smartSpeed: 1500,
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 1,
            },
            1000: {
                items: 1,
            },
        },
    };
}
